export const AUTH_FAILED: number = 101001;
export const FETCH_SUCCESS: number = 0;
